/*
JOSEPH P. PASAOA
UserSimAuth Reducer | Portfolio Site
*/


/* IMPORTS */
// import { AN_ACTION } from '../actionTypes';


/* MAIN */
const INITIAL_STATE = {
  cId: 6
}

const userAuthReducer = (state = INITIAL_STATE, action) => {
  const newState = { ...state };
  return newState;
}


export default userAuthReducer;
